module.exports = __webpack_public_path__ + "img/text-options.c53c206e.png";